<template>
  <div
    :class="{'my-slider__disabled' : disabled}"
    class="my-slider"
  >
    <vue-slider
      v-model="data"
      :adsorb="true"
      :interval="option.interval || 1"
      :marks="true"
      class="mb-3"
      :min="option.numberMin"
      :max="option.numberMax"
    />
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'

export default {
  components: {
    VueSlider,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
    }
  },
  computed: {

  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        this.data = e || this.option.numberMax
      },
      deep: true,
      immediate: true,
    },
  },
}

</script>

<style lang='scss' >
@import "@core/scss/vue/libs/vue-slider.scss";
</style>
<style lang="scss" scoped>
.my-slider{
    padding: 0 20px;
    &__disabled{

    }
}
</style>
